// extracted by mini-css-extract-plugin
export default {"header":"GroupsPage_header__x1FPF","headerText":"GroupsPage_headerText__y4bhL"};